
import Home from "../../../assets/filled/Home.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HomeIcon({ className, dataTestid = "HomeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Home data-testid={dataTestid} className={classes} {...rest} />
  );
}
